import React from 'react';
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import MyAppBar from '../../components/MyAppBar';

const styles = {
  container: {
    // padding: 10,
    padding: 1,
  },
  paper: {
    // margin: 20,
    // padding: 10,
    margin: 2,
    padding: 2,
  },
};

class A extends React.Component {
  render() {
    return (
      <React.Fragment>
        <MyAppBar title='Appendix A - Abbreviations/Acronyms' />
        <Container sx={styles.container}>
          <Paper sx={styles.paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant='h6'>Code</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant='h6'>Description</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>CWA</TableCell>
                  <TableCell>Coastal Water Authority</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>ft</TableCell>
                  <TableCell>Foot, Feet</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>gpd</TableCell>
                  <TableCell>Gallons per Day</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>gpm</TableCell>
                  <TableCell>Gallons per Minute</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>in.</TableCell>
                  <TableCell>Inch, Inches</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>MG</TableCell>
                  <TableCell>Million Gallons</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>MGD</TableCell>
                  <TableCell>Million Gallons per Day</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>MGY</TableCell>
                  <TableCell>Million Gallons per Year</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
        </Container>
      </React.Fragment>
    );
  }
}

export default A;
